import { Button, Descriptions, Typography } from "antd";
const { Title } = Typography;

const CartransferDetailsForm = ({ cartransfer }) => {
  const { buyer, seller, permission } = cartransfer;
  const {
    model,
    make,
    year,
    price,
    type,
    inscription,
    appraisal,
    motor,
    chasis,
  } = cartransfer.contract;
  return (
    <div>
      <Title>
        {/* Transferencia {repertory} */}
        {cartransfer.folder_contract_original && (
          <Button
            style={{ margin: 10 }}
            onClick={() => window.open(cartransfer.folder_contract_signed)}
            disabled={!cartransfer.folder_contract_signed}
          >
            {cartransfer.folder_contract_signed
              ? "Descargar contrato"
              : "Contrato no firmado"}
          </Button>
        )}
      </Title>

      <Title level={2}>Digital Notary</Title>

      {/* Sección de notario comentada - variable notary no definida
      <Descriptions
        style={{ margin: 10 }}
        title="Notario"
        bordered
        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
      >
        <Descriptions.Item label="RUT">{notary?.fullRut}</Descriptions.Item>
        <Descriptions.Item label="Apellido Paterno">
          {notary?.firstLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Apellido Materno">
          {notary?.secondLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Nombres">{notary?.names}</Descriptions.Item>
        <Descriptions.Item label="Direccion">
          {notary?.address}
        </Descriptions.Item>
        <Descriptions.Item label="Comuna">{notary?.commune}</Descriptions.Item>
        <Descriptions.Item label="Teléfono">{notary?.phone}</Descriptions.Item>
      </Descriptions>
      */}
      <Descriptions
        style={{ margin: 10 }}
        title="Vendedor"
        bordered
        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
      >
        <Descriptions.Item label="RUT">{seller?.fullRut}</Descriptions.Item>
        <Descriptions.Item label="Apellido Paterno">
          {seller?.firstLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Apellido Materno">
          {seller?.secondLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Nombres">{seller?.names}</Descriptions.Item>
        <Descriptions.Item label="Dirección">
          {seller?.address}
        </Descriptions.Item>
        <Descriptions.Item label="Comuna">{seller?.commune}</Descriptions.Item>
        <Descriptions.Item label="Teléfono">{seller?.phone}</Descriptions.Item>
      </Descriptions>
      <Descriptions
        style={{ margin: 10 }}
        title="Comprador"
        bordered
        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
      >
        <Descriptions.Item label="RUT">{buyer?.fullRut}</Descriptions.Item>
        <Descriptions.Item label="Apellido Paterno">
          {buyer?.firstLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Apellido Materno">
          {buyer?.secondLastName}
        </Descriptions.Item>
        <Descriptions.Item label="Nombres">{buyer?.names}</Descriptions.Item>
        <Descriptions.Item label="Dirección">
          {buyer?.address}
        </Descriptions.Item>
        <Descriptions.Item label="Comuna">{buyer?.commune}</Descriptions.Item>
        <Descriptions.Item label="Teléfono">{buyer?.phone}</Descriptions.Item>
      </Descriptions>
      <Descriptions
        style={{ margin: 10 }}
        title="Vehiculo"
        bordered
        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
      >
        <Descriptions.Item label="Tipo">{type}</Descriptions.Item>
        <Descriptions.Item label="Marca">{make}</Descriptions.Item>
        <Descriptions.Item label="Modelo">{model}</Descriptions.Item>
        <Descriptions.Item label="Año">{year}</Descriptions.Item>
        <Descriptions.Item label="Patente">{inscription}</Descriptions.Item>
        <Descriptions.Item label="Motor">{motor}</Descriptions.Item>
        <Descriptions.Item label="Chasis">{chasis}</Descriptions.Item>
        <Descriptions.Item label="Comuna Permiso">
          {permission.commune}
        </Descriptions.Item>
        <Descriptions.Item label="Código SII">
          {permission.siicode}
        </Descriptions.Item>
        <Descriptions.Item label="Precio de venta">{price}</Descriptions.Item>
        <Descriptions.Item label="Avalúo">{appraisal}</Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default CartransferDetailsForm;
